<template>
  <div class="contact-page">
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />
    <div class="min-height-300 bg-primary position-absolute w-100"></div>
    <page-hero
      title="Contact"
      subtitle="Contactez-nous"
      description="Notre équipe est à votre écoute pour répondre à vos questions."
      :showBreadcrumb="true"
    />
    <main class="main-content position-relative border-radius-lg">
      <div class="container-fluid py-4">
        <div class="row">
          <div class="col-lg-8 mb-4">
            <div class="card h-100">
              <div class="card-header pb-0">
                <h5 class="font-weight-bolder">Envoyez-nous un message</h5>
              </div>
              <div class="card-body">
                <form @submit.prevent="submitForm">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-control-label">Nom</label>
                        <input 
                          type="text" 
                          class="form-control" 
                          v-model="form.lastName"
                          required
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-control-label">Prénom</label>
                        <input 
                          type="text" 
                          class="form-control" 
                          v-model="form.firstName"
                          required
                        >
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-control-label">Email</label>
                        <input 
                          type="email" 
                          class="form-control" 
                          v-model="form.email"
                          required
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-control-label">Téléphone</label>
                        <input 
                          type="tel" 
                          class="form-control" 
                          v-model="form.phone"
                        >
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-control-label">Société</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="form.company"
                    >
                  </div>
                  <div class="form-group">
                    <label class="form-control-label">Sujet</label>
                    <select class="form-control" v-model="form.subject" required>
                      <option value="">Choisissez un sujet</option>
                      <option value="information">Demande d'information</option>
                      <option value="devis">Demande de devis</option>
                      <option value="demo">Démonstration</option>
                      <option value="support">Support technique</option>
                      <option value="other">Autre</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label class="form-control-label">Message</label>
                    <textarea 
                      class="form-control" 
                      rows="6" 
                      v-model="form.message"
                      required
                    ></textarea>
                  </div>
                  <div class="form-group">
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        v-model="form.consent"
                        required
                        id="consent"
                      >
                      <label class="form-check-label" for="consent">
                        J'accepte que mes données soient traitées conformément à la
                        <router-link to="/privacy">politique de confidentialité</router-link>.
                      </label>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mt-4">
                    <button 
                      type="submit" 
                      class="btn bg-gradient-primary"
                      :disabled="loading"
                    >
                      <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                      {{ loading ? 'Envoi en cours...' : 'Envoyer le message' }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card mb-4">
              <div class="card-body">
                <h5 class="font-weight-bolder mb-4">Nos coordonnées</h5>
                <div class="d-flex mb-4">
                  <div>
                    <div class="icon icon-shape bg-gradient-primary shadow text-center border-radius-md">
                      <i class="ni ni-pin-3 text-lg opacity-10" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div class="ms-3">
                    <h6 class="text-gradient text-primary mb-0">Adresse</h6>
                    <p>1 rue de la Paix<br>75002 Paris<br>France</p>
                  </div>
                </div>
                <div class="d-flex mb-4">
                  <div>
                    <div class="icon icon-shape bg-gradient-primary shadow text-center border-radius-md">
                      <i class="ni ni-email-83 text-lg opacity-10" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div class="ms-3">
                    <h6 class="text-gradient text-primary mb-0">Email</h6>
                    <p>contact@nolido.com</p>
                  </div>
                </div>
                <div class="d-flex">
                  <div>
                    <div class="icon icon-shape bg-gradient-primary shadow text-center border-radius-md">
                      <i class="ni ni-mobile-button text-lg opacity-10" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div class="ms-3">
                    <h6 class="text-gradient text-primary mb-0">Téléphone</h6>
                    <p>+33 1 23 45 67 89</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h5 class="font-weight-bolder mb-4">Notre localisation</h5>
                <div class="map border-radius-lg">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.2125300495147!2d2.3275863158061334!3d48.86952170762712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e3c844f78e1%3A0x3c8117c7fb7c3f0!2s1%20Rue%20de%20la%20Paix%2C%2075002%20Paris!5e0!3m2!1sfr!2sfr!4v1609859510000!5m2!1sfr!2sfr"
                    width="100%"
                    height="250"
                    style="border:0;"
                    allowfullscreen=""
                    loading="lazy"
                    class="border-radius-lg shadow-sm"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    
    <!-- Composants requis -->
    <testimonials-section />
    <faq-section />
    <cta-section />
    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import PageHero from '@/components/PageHero.vue';
import TestimonialsSection from '@/components/TestimonialsSection.vue';
import FaqSection from '@/components/FaqSection.vue';
import CtaSection from '@/components/CtaSection.vue';

export default {
  name: 'ContactPage',
  components: {
    Navbar,
    AppFooter,
    PageHero,
    TestimonialsSection,
    FaqSection,
    CtaSection
  },
  data() {
    return {
      loading: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        company: '',
        subject: '',
        message: '',
        consent: false
      }
    }
  },
  methods: {
    async submitForm() {
      this.loading = true
      try {
        // Simuler un délai d'envoi
        await new Promise(resolve => setTimeout(resolve, 1000))
        
        // Ici, vous devrez implémenter l'envoi réel du formulaire à votre backend
        console.log('Form submitted:', this.form)
        
        // Réinitialiser le formulaire
        this.form = {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          company: '',
          subject: '',
          message: '',
          consent: false
        }
        
        // Afficher un message de succès
        this.$swal({
          icon: 'success',
          title: 'Message envoyé !',
          text: 'Nous vous répondrons dans les plus brefs délais.',
          confirmButtonText: 'OK'
        })
      } catch (error) {
        // Gérer les erreurs
        this.$swal({
          icon: 'error',
          title: 'Erreur',
          text: 'Une erreur est survenue lors de l\'envoi du message. Veuillez réessayer.',
          confirmButtonText: 'OK'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}

.form-control-label {
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #344767;
}

.form-control {
  border: 1px solid #d2d6da;
  padding: 0.5rem 0.75rem;
}

.form-control:focus {
  border-color: #cb0c9f;
  box-shadow: 0 0 0 2px rgba(203, 12, 159, 0.25);
}

.form-check-label {
  color: #67748e;
  font-size: 0.875rem;
}

.map {
  overflow: hidden;
}
</style>
